import {Project} from "../../../../api/Projects";
import {DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {api} from "../../../../api/API";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import React, {useState} from "react";
import {FindOrCreateCompany} from "./FindOrCreateCompany";
import {useConfirm} from "../../../../misc/Confirm";

export function ClientEdit(props: {
    value: Project;
    onDone(): void;
}) {
    const onDoneRef = useSyncedRef(props.onDone);
    const update = useAsyncAction(async input => {
        await api.projects.upsert(input)
        onDoneRef.current();
    }, [])

    const [owner, setOwner] = useState<null | {id: number; name: string;}>(props.value.client ? {
        id: props.value.client,
        name: props.value.clientName || "",
    } : null);

    const confirm = useConfirm();

    const submit = () => {
        update.callback(Object.assign({}, props.value, {
            client: owner?.id,
        }));
    };

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>Owner</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <FindOrCreateCompany
                    value={owner}
                    kind={"client"}
                    label="Owner"
                    onChange={setOwner} />
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onSubmit={submit}
                onCancel={props.onDone}
                onDestroy={async () => {
                    const ok = await confirm.confirm("Are you sure you want to remove the owner?")
                    if(!ok) return;

                    update.callback(Object.assign({}, props.value, {
                        client: null,
                    }));
                }}
                destroyLoading={update.loading}
                destroyName="Remove"
                destroyingWord="Removing…"
            />
        </Dialog2>
    )
}